module.exports = __webpack_public_path__ + "static/media/yon.de414117.png";